import ApplicationController from "./app_intro_controller";

export default class AnalyticsDateSelectController extends ApplicationController {
  dateChange(event) {
    this.dispatch('dateChange', { detail: { content: event.target.value }});
  }
}
